type ChevronDownAccentProps = {
  className?: string;
};

export default function ChevronDownAccent({ className }: ChevronDownAccentProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M8.23083 9.06667L11.2975 6L12 6.7025L8.23083 10.4717L4.46167 6.7025L5.16417 6L8.23083 9.06667Z"
        fill="currentColor"
      />
    </svg>
  );
}
